import React from "react";
import "./FooterStyle.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFutbol } from "@fortawesome/free-regular-svg-icons";
import { faChartLine, faListNumeric, faPeopleGroup } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <div className="footerContainer">
      <div className="row">
        <a
          href="https://www.fotmob.com/leagues/47/overview/premier-league"
          className="football social">
          <FontAwesomeIcon className="social" icon={faFutbol} size="2x" />
        </a>
        <a
          href="https://www.premierleague.com/"
          className="stats social">
          <FontAwesomeIcon className="social" icon={faChartLine} size="2x" />
        </a>
        <a
          href="https://www.transfermarkt.com/premier-league/startseite/wettbewerb/GB1"
          className="team social">
          <FontAwesomeIcon className="social" icon={faPeopleGroup} size="2x" />
        </a>
        <a
          href="https://www.zerozero.pt/edition.php?id=155962"
          className="instagram social">
          <FontAwesomeIcon className="social" icon={faListNumeric} size="2x" />
        </a>
      </div>
    </div>
  )
}

export default Footer;